import { render, staticRenderFns } from "./ticket-collaborator.html?vue&type=template&id=8f318f12&"
import script from "./ticket-collaborator.js?vue&type=script&lang=js&"
export * from "./ticket-collaborator.js?vue&type=script&lang=js&"
import style0 from "../Ticketing.scss?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports